import Container from './Container'
export { ErrorBoundary } from '~/components'

export default function MapLayout() {
  return <Container />
}
